import type {
  BankingDetails,
  CurrentAddress,
  EmploymentDetails,
  LoanDetailsUserInput,
  PersonalDetails,
  PreviousAddress,
} from '../../../../../components/CarFinancePage/queries/schema/carFinance.schema';

/**
 * We use these default values to determine what the initial state of a required field, that is clearable, should be
 * and whether it has been updated.
 *
 * Without a default value, a field may be initially undefined. Providing input and subsequently
 * clearing a field may leave the value as an empty string.
 *
 * That empty string may be mistaken for input and incorrectly determine that the field is completed.
 */

/**
 * We exclude dateofBirth since once the date is set, it can not be cleared.
 * As such, there is no need to compare it to an initial state.
 */
const clearableRequiredFieldsDefaultValuesPersonalDetails: Omit<
  PersonalDetails,
  'dateOfBirth'
> = {
  title: '',
  firstName: '',
  surname: '',
  phone: '',
  email: '',
  maritalStatus: '',
  ppsNumber: '',
  gender: '',
};

const requiredDefaultValuesLoanDetails: LoanDetailsUserInput = {
  cashDeposit: 0,
  totalDeposit: 0,
  financeAmount: 0,
  tradeInValue: 0,
};

const clearableRequiredFieldsDefaultValuesCurrentAddress: CurrentAddress = {
  residentialStatus: '',
  addressLine1: '',
  county: '',
  timeAtCurrentAddress: {
    years: '',
  },
};

const clearableRequiredFieldsDefaultValuesPreviousAddress: PreviousAddress = {
  addressLine1: '',
  county: '',
};

const clearableRequiredFieldsDefaultValuesEmploymentDetails: EmploymentDetails =
  {
    occupation: '',
    status: '',
    employerName: '',
    timeWithEmployer: {
      years: '',
    },
  };

const clearableRequiredFieldsDefaultValuesBankingDetails: BankingDetails = {
  income: 0,
  bankName: '',
  monthlyMortgageRent: 0,
};

export {
  clearableRequiredFieldsDefaultValuesPreviousAddress,
  clearableRequiredFieldsDefaultValuesCurrentAddress,
  clearableRequiredFieldsDefaultValuesEmploymentDetails,
  clearableRequiredFieldsDefaultValuesPersonalDetails,
  clearableRequiredFieldsDefaultValuesBankingDetails,
  requiredDefaultValuesLoanDetails,
};
